import { EntityAction, EntityRawAction } from '../interfaces/entity-actions';

export function EntityActionsFactory<T>(
  rawActions: EntityRawAction<T>[],
  actionDisplayDetails: EntityAction<T>[]
): EntityAction<T>[] {
  return actionDisplayDetails
    .filter(action => rawActions.some(a => a.type === action.action))
    .map(action => {
      const matchedAction = rawActions.find(a => a.type === action.action);

      return {
        ...action,
        disabled: !!matchedAction?.is_disabled,
        disabledReason: matchedAction?.disabled_reason,
        meta: matchedAction?.meta
      };
    });
}
